import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import IntroScreen from "./components/IntroScreen";
import ModulesScreen from "./components/ModulesScreen";
import DialogScene from "./components/DialogScene";
import ProductShowcase from "./components/ProductShowcase";
import ResultScreen from "./components/ResultScreen";
import { Toaster } from "@/components/ui/sonner";

// Application screens
const SCREENS = {
  INTRO: 'intro',
  MODULES: 'modules',
  DIALOG: 'dialog',
  PRODUCTS: 'products',
  RESULT: 'result',
};

function App() {
  const [screen, setScreen] = useState(SCREENS.INTRO);
  const [finalScore, setFinalScore] = useState(0);
  const [completedModules, setCompletedModules] = useState([]);

  const handleStart = () => setScreen(SCREENS.MODULES);

  const handleSelectModule = (moduleId) => {
    if (moduleId === 2) {
      setScreen(SCREENS.DIALOG);
    } else if (moduleId === 3) {
      setScreen(SCREENS.PRODUCTS);
    } else {
      // For modules 1, just go to dialog as placeholder
      setScreen(SCREENS.DIALOG);
    }
  };

  const handleDialogComplete = (score) => {
    setFinalScore(score);
    setCompletedModules(prev => [...new Set([...prev, 2])]);
    setScreen(SCREENS.RESULT);
  };

  const handleRestart = () => {
    setFinalScore(0);
    setScreen(SCREENS.MODULES);
  };

  const handleShowProducts = () => {
    setScreen(SCREENS.PRODUCTS);
  };

  const handleBackFromProducts = () => {
    setScreen(screen === SCREENS.PRODUCTS && completedModules.includes(2)
      ? SCREENS.RESULT
      : SCREENS.MODULES
    );
  };

  return (
    <div className="presentation-root">
      <AnimatePresence mode="wait">
        {screen === SCREENS.INTRO && (
          <motion.div
            key="intro"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <IntroScreen onStart={handleStart} />
          </motion.div>
        )}

        {screen === SCREENS.MODULES && (
          <motion.div
            key="modules"
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -30 }}
            transition={{ duration: 0.35 }}
          >
            <ModulesScreen
              onSelectModule={handleSelectModule}
              completedModules={completedModules}
            />
          </motion.div>
        )}

        {screen === SCREENS.DIALOG && (
          <motion.div
            key="dialog"
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -30 }}
            transition={{ duration: 0.35 }}
          >
            <DialogScene onComplete={handleDialogComplete} />
          </motion.div>
        )}

        {screen === SCREENS.RESULT && (
          <motion.div
            key="result"
            initial={{ opacity: 0, scale: 0.97 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.97 }}
            transition={{ duration: 0.35 }}
          >
            <ResultScreen
              score={finalScore}
              onRestart={handleRestart}
              onShowProducts={handleShowProducts}
            />
          </motion.div>
        )}

        {screen === SCREENS.PRODUCTS && (
          <motion.div
            key="products"
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -30 }}
            transition={{ duration: 0.35 }}
          >
            <ProductShowcase onBack={handleBackFromProducts} />
          </motion.div>
        )}
      </AnimatePresence>

      <Toaster />
    </div>
  );
}

export default App;
